(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[513],{

/***/ 313:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);



var Image = function(param) {
    var _src = param.src, src = _src === void 0 ? "" : _src, width = param.width, height = param.height, className = param.className, _alt = param.alt, alt = _alt === void 0 ? "" : _alt, layout = param.layout, loading = param.loading, quality = param.quality, priority = param.priority, title = param.title, onClick = param.onClick, objectFit = param.objectFit;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
        src: src,
        width: width,
        height: height,
        className: className,
        alt: alt,
        layout: layout,
        loading: loading,
        quality: quality,
        priority: priority,
        title: title,
        onClick: onClick,
        objectFit: objectFit
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(Image));


/***/ }),

/***/ 2304:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9521);
/* harmony import */ var styles_animations__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3167);
/* harmony import */ var images_global_loader_png__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4072);
/* harmony import */ var images_global_loader_png__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(images_global_loader_png__WEBPACK_IMPORTED_MODULE_4__);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      position: absolute;\n      top: 50%;\n      left: 50%;\n      width: 100vw;\n      transform: translate(-50%, -50%);\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n\n  .loader {\n    border: none;\n    background-image: url(",
        ");\n    background-repeat: no-repeat;\n    background-size: 100%;\n    border-radius: 50%;\n    margin: 1rem auto;\n    width: 50px;\n    height: 50px;\n    animation: ",
        " 0.8s infinite linear;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





var Loader = function(param) {
    var abCenter = param.abCenter;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledLoader, {
        abCenter: abCenter,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
            role: "presentation",
            className: "loader"
        })
    });
};
var StyledLoader = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-b3e25d50-0"
})(_templateObject1(), function(props) {
    return props.abCenter && (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)(_templateObject());
}, (images_global_loader_png__WEBPACK_IMPORTED_MODULE_4___default()), styles_animations__WEBPACK_IMPORTED_MODULE_3__/* .rotate */ .U1);
/* harmony default export */ __webpack_exports__["Z"] = (Loader);


/***/ }),

/***/ 2513:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "jR": function() { return /* reexport */ AccountInputCss; },
  "zx": function() { return /* reexport */ common_Button; },
  "$_": function() { return /* reexport */ common_Footer; },
  "PJ": function() { return /* reexport */ Icons; },
  "Ee": function() { return /* reexport */ Image/* default */.Z; },
  "II": function() { return /* reexport */ Input; },
  "rU": function() { return /* reexport */ Link/* default */.Z; },
  "aN": function() { return /* reexport */ Loader/* default */.Z; },
  "Vm": function() { return /* reexport */ common_Messages; },
  "HJ": function() { return /* reexport */ common_SEO; }
});

// UNUSED EXPORTS: Header, Layout

// EXTERNAL MODULE: ./components/common/Layout/index.tsx
var Layout = __webpack_require__(4367);
// EXTERNAL MODULE: ./components/common/Header/index.tsx
var Header = __webpack_require__(2115);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(9521);
// EXTERNAL MODULE: ./styles/colors.ts
var colors = __webpack_require__(2317);
// EXTERNAL MODULE: ./styles/helper.ts + 1 modules
var helper = __webpack_require__(9900);
// EXTERNAL MODULE: ./lib/hooks/index.ts + 8 modules
var hooks = __webpack_require__(9434);
// EXTERNAL MODULE: ./constants/index.ts
var constants = __webpack_require__(1407);
// EXTERNAL MODULE: ./components/common/Link/index.tsx
var Link = __webpack_require__(6754);
;// CONCATENATED MODULE: ./components/common/Footer/index.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      margin-bottom: 75px;\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex: 1;\n  align-items: flex-end;\n  text-align: center;\n  width: 100%;\n  height: 220px;\n  color: ",
        ";\n  font-size: 10px;\n  line-height: 1.8em;\n  opacity: 50%;\n  .inner {\n    max-width: 350px;\n    margin: 0 auto;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    align-self: flex-end;\n    ",
        "\n  }\n  hr {\n    width: 100%;\n    max-width: 300px;\n    opacity: 50%;\n  }\n  a {\n    display: inline-block;\n    text-decoration: none;\n    span {\n      border-bottom: 0.5px solid;\n    }\n  }\n  .helpLink {\n    font-size: 14px;\n    color: ",
        ";\n    font-family: 'Graphik', serif;\n    font-weight: 600;\n    text-decoration: none;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}








var Footer = function() {
    var language_strings_en_US = (0,hooks/* useLanguageStrings */.F2)().language_strings_en_US;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledFooter, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
            className: "inner",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                    className: "helpLink",
                    external: true,
                    href: constants/* LINKS.HELP_LINK */.BA.HELP_LINK,
                    target: constants/* LINKS.target */.BA.target,
                    children: language_strings_en_US === null || language_strings_en_US === void 0 ? void 0 : language_strings_en_US.auth_selectProviderHelpText
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                    className: "helpLink"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "legal",
                    children: [
                        "\xa9 ",
                        new Date().getFullYear(),
                        " FOX. All Rights Reserved. Use of this website ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        " assumes acceptance of the",
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                            external: true,
                            href: constants/* LINKS.TERMS_LINK */.BA.TERMS_LINK,
                            target: constants/* LINKS.target */.BA.target,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "Terms of Use."
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                            "data-testid": "link",
                            external: true,
                            href: constants/* LINKS.DO_NOT_SELL_LINK */.BA.DO_NOT_SELL_LINK,
                            target: constants/* LINKS.target */.BA.target,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: language_strings_en_US === null || language_strings_en_US === void 0 ? void 0 : language_strings_en_US.ccpa_do_not_sell_label.toUpperCase()
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var common_Footer = (Footer);
var StyledFooter = styled_components_browser_esm/* default.footer.withConfig */.ZP.footer.withConfig({
    componentId: "sc-7941e68b-0"
})(_templateObject1(), colors/* default.white */.ZP.white, helper/* respondTo.bp_767 */.s.bp_767(_templateObject()), colors/* default.white */.ZP.white);

// EXTERNAL MODULE: ./components/common/Image/index.tsx
var Image = __webpack_require__(313);
;// CONCATENATED MODULE: ./components/common/Input/index.ts

function Input_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 50px;\n  padding-left: 1rem;\n  border-radius: 6px;\n  outline: none;\n  background: ",
        ";\n  border: none;\n  color: inherit;\n  font-size: 17px;\n  font-weight: 600;\n  text-align: center;\n  &:focus:not(.error) {\n    outline: 0;\n    color: ",
        ";\n    background: ",
        ";\n  }\n"
    ]);
    Input_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Input_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 340px;\n  font-weight: normal;\n  text-align: left;\n  color: ",
        ";\n  &:focus,\n  :active {\n    color: ",
        ";\n    &::placeholder {\n      color: ",
        ";\n      opacity: 0.5;\n    }\n  }\n  &::placeholder {\n    color: ",
        ";\n    opacity: 0.5;\n  }\n"
    ]);
    Input_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var Input = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
    componentId: "sc-cbea6ce5-0"
})(Input_templateObject(), colors/* fox.white10 */.vn.white10, colors/* default.white */.ZP.white, colors/* default.white10 */.ZP.white10);
var AccountInputCss = (0,styled_components_browser_esm/* css */.iv)(Input_templateObject1(), colors/* default.white */.ZP.white, colors/* default.white */.ZP.white, colors/* default.white */.ZP.white, colors/* default.white */.ZP.white);


;// CONCATENATED MODULE: ./styles/index.ts
var getThemeValue = function(name, props, values) {
    var value = props === null || props === void 0 ? void 0 : props.theme[name];
    var themeValue;
    if (typeof value === "function") {
        if (values) {
            themeValue = values[Number(value)];
        }
    } else {
        themeValue = values[value];
    }
    if (typeof themeValue === "function") {
        return themeValue(props);
    } else {
        return themeValue;
    }
};
var theme = function(name, values) {
    return function(props) {
        return getThemeValue(name, props, values);
    };
};
theme.variants = function(name, prop, values) {
    return function(props) {
        var variant = props[prop] && values[props[prop]];
        return variant && getThemeValue(name, props, variant);
    };
};
/* harmony default export */ var styles = (theme);

;// CONCATENATED MODULE: ./components/common/Button/index.ts

function Button_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font: inherit;\n  background: ",
        ";\n  color: ",
        ";\n  color: ",
        ";\n  position: relative;\n  display: flex;\n  width: 100%;\n  max-width: 340px;\n  height: 44px;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  border: none;\n  border: ",
        ";\n  margin: 20px auto;\n  border-radius: 22px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 600;\n  letter-spacing: -0.25px;\n  outline: 0;\n  transition: ease all 200ms;\n  &:hover {\n    background: ",
        ";\n    color: ",
        ";\n    border: ",
        ";\n    transition: ease all 200ms;\n  }\n  &:disabled {\n    background: ",
        ";\n    cursor: initial;\n    opacity: 0.5;\n    color: ",
        ";\n  }\n"
    ]);
    Button_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var background = styles.variants("brand", "kind", {
    default: {
        fox: colors/* fox.bluePrimary */.vn.bluePrimary,
        sports: colors/* sports.endeavour */.e8.endeavour,
        nation: colors/* nation.hitGray */.xf.hitGray
    },
    secondary: {
        fox: colors/* default.white */.ZP.white,
        sports: colors/* default.white */.ZP.white,
        nation: colors/* default.white */.ZP.white
    },
    hollow: {
        fox: colors/* default.transparent */.ZP.transparent,
        sports: colors/* default.transparent */.ZP.transparent,
        nation: colors/* default.transparent */.ZP.transparent
    }
});
var border = styles.variants("brand", "kind", {
    default: {
        fox: colors/* fox.border */.vn.border,
        sports: colors/* sports.border */.e8.border,
        nation: colors/* nation.border */.xf.border
    },
    hollow: {
        fox: "1px solid ".concat(colors/* fox.white25 */.vn.white25),
        sports: "1px solid ".concat(colors/* sports.endeavour */.e8.endeavour),
        nation: "1px solid ".concat(colors/* nation.hitGray */.xf.hitGray)
    }
});
var textColor = styles.variants("brand", "kind", {
    default: {
        fox: colors/* default.white */.ZP.white,
        sports: colors/* default.white */.ZP.white,
        nation: colors/* default.white */.ZP.white
    },
    secondary: {
        fox: colors/* default.black */.ZP.black,
        sports: colors/* default.black */.ZP.black,
        nation: colors/* default.black */.ZP.black
    }
});
var Button = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-5ac54cc4-0"
})(Button_templateObject(), background, function(param) {
    var _$theme = param.theme;
    var ref;
    return _$theme === null || _$theme === void 0 ? void 0 : (ref = _$theme.colors) === null || ref === void 0 ? void 0 : ref.button.text;
}, textColor, border, function(param) {
    var _$theme = param.theme;
    var ref;
    return _$theme === null || _$theme === void 0 ? void 0 : (ref = _$theme.colors) === null || ref === void 0 ? void 0 : ref.button.background;
}, function(param) {
    var _$theme = param.theme;
    var ref;
    return _$theme === null || _$theme === void 0 ? void 0 : (ref = _$theme.colors) === null || ref === void 0 ? void 0 : ref.button.text;
}, function(param) {
    var _$theme = param.theme;
    var ref;
    return _$theme === null || _$theme === void 0 ? void 0 : (ref = _$theme.colors) === null || ref === void 0 ? void 0 : ref.button.background;
}, function(param) {
    var _$theme = param.theme;
    var ref;
    return _$theme === null || _$theme === void 0 ? void 0 : (ref = _$theme.colors) === null || ref === void 0 ? void 0 : ref.button.background;
}, function(param) {
    var _$theme = param.theme;
    var ref;
    return _$theme === null || _$theme === void 0 ? void 0 : (ref = _$theme.colors) === null || ref === void 0 ? void 0 : ref.button.disabled;
});
/* harmony default export */ var common_Button = (Button);

// EXTERNAL MODULE: ./components/common/Loader/index.tsx
var Loader = __webpack_require__(2304);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react-cookie/es6/useCookies.js + 1 modules
var useCookies = __webpack_require__(708);
// EXTERNAL MODULE: ./lib/hooks/useFlowManager.ts
var useFlowManager = __webpack_require__(9697);
// EXTERNAL MODULE: ./components/common/Icons/CheckMark.tsx
var CheckMark = __webpack_require__(2950);
// EXTERNAL MODULE: ./context/GlobalContextProvider.tsx
var GlobalContextProvider = __webpack_require__(1387);
;// CONCATENATED MODULE: ./components/common/Messages/index.tsx


function Messages_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 20px;\n    letter-spacing: -0.3px;\n  "
    ]);
    Messages_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Messages_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-size: 15px;\n  font-family: Graphik, serif;\n  font-weight: normal;\n  letter-spacing: -0.27px;\n  line-height: 20px;\n  ",
        "\n"
    ]);
    Messages_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 40px;\n    letter-spacing: -0.5px;\n    line-height: 45px;\n    margin: 25px 0 50px;\n	"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 50px;\n  font-family: Graphik, serif;\n  font-size: 19px;\n  font-weight: 600;\n  line-height: 22px;\n  letter-spacing: 0;\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}











var string = {
    profileSignedIn: "You're signed in!",
    profileSignedUp: "Your profile has been created!",
    mainTitle: "Select TV Provider"
};
var Messages = function(param) {
    var _isNationAuthSuccess = param.isNationAuthSuccess, isNationAuthSuccess = _isNationAuthSuccess === void 0 ? false : _isNationAuthSuccess;
    var ref, ref1;
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useCookies/* default */.Z)([
        constants/* ACCOUNT_COOKIE_NAME_FOX */.EO,
        constants/* COOKIE_CODE_INFO */.r5
    ]), 1), cookies = ref2[0];
    var ref3 = (0,useFlowManager/* default */.Z)(), isMVPD = ref3.isMVPD, isNew = ref3.isNew, isNation = ref3.isNation;
    var ref4 = (0,react.useContext)(GlobalContextProvider/* AppContext */.I), _state = ref4.state, siteUrl = _state.config.siteUrl, _isRegister = _state.isRegister, isRegister = _isRegister.value;
    var mainTitle = /*#__PURE__*/ (0,jsx_runtime.jsx)(H1, {
        children: string.mainTitle
    });
    if (isNation && isNationAuthSuccess) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckMark/* default */.Z, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Message, {
                    children: "Thank you for signing in to Fox Nation!"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(H1, {
                    children: "You may now return to your TV and enjoy Fox Nation content."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonLink, {
                    external: true,
                    href: "".concat(siteUrl),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Button, {
                        children: "Home"
                    })
                })
            ]
        });
    }
    if (((ref = cookies[constants/* ACCOUNT_COOKIE_NAME_FOX */.EO]) === null || ref === void 0 ? void 0 : ref.accountType) !== constants/* ANONYMOUS */.o2 || isNew || isRegister) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckMark/* default */.Z, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Message, {
                    children: isRegister ? string.profileSignedUp : string.profileSignedIn
                }),
                mainTitle
            ]
        });
    }
    if (isMVPD || ((ref1 = cookies[constants/* COOKIE_CODE_INFO */.r5]) === null || ref1 === void 0 ? void 0 : ref1.isAnonymous)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: mainTitle
        });
    }
    return null;
};
/* harmony default export */ var common_Messages = (Messages);
var Message = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-c013612-0"
})(Messages_templateObject1(), colors/* default.white */.ZP.white, helper/* respondTo.bp_767 */.s.bp_767(Messages_templateObject()));
var H1 = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
    componentId: "sc-c013612-1"
})(_templateObject3(), helper/* respondTo.bp_767 */.s.bp_767(_templateObject2()));
var ButtonLink = (0,styled_components_browser_esm/* default */.ZP)(Link/* default */.Z).withConfig({
    componentId: "sc-c013612-2"
})(_templateObject4());

// EXTERNAL MODULE: ./components/common/Icons/index.ts + 9 modules
var Icons = __webpack_require__(7783);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./lib/utils/configs.ts
var configs = __webpack_require__(2670);
;// CONCATENATED MODULE: ./components/common/SEO/index.tsx




var SEO = function(param) {
    var title = param.title;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
        title: title,
        titleTemplate: "Second Screen Activation | %s",
        openGraph: {
            type: "website",
            locale: "en_IE",
            url: configs/* config.registrationUrl */.vc.registrationUrl,
            site_name: "Second Screen Activation"
        }
    });
};
/* harmony default export */ var common_SEO = (SEO);

;// CONCATENATED MODULE: ./components/common/index.tsx














/***/ }),

/***/ 3167:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U1": function() { return /* binding */ rotate; },
/* harmony export */   "jF": function() { return /* binding */ fadein; }
/* harmony export */ });
/* unused harmony export fadeinKeyFrames */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9521);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 100%;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  animation: ",
        " 100ms cubic-bezier(0.4, 0, 0.2, 1);\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

var rotate = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .keyframes */ .F4)(_templateObject());
var fadeinKeyFrames = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .keyframes */ .F4)(_templateObject1());
var fadein = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject2(), fadeinKeyFrames);


/***/ }),

/***/ 4072:
/***/ (function(module) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAMAAABg3Am1AAAAtFBMVEUAAAD////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////oK74hAAAAPHRSTlMACgMHEh1zZhVLPTYk13hOQisYvY6GRjIh9aahmFZTLg64YSjv6dLFr6uck4mBbmpb++Xcs3w64M3KwV4uvJj/AAACYUlEQVRIx43V53LqMBAFYBX3ggu4YNywQzPEphuS93+vu0qGXLp1/lDmfCPtAgN6CNVlbzQf9/fRoNYo6gi2e4v9eDzu9/tfX7PZ7Gtg5W/qNI3m8/0VOJ/Pp5mMX9SJHS8WDOyvwOl0mvYT8qwveNGCgXkl25mIsRj49RzAdDo1F+5j31hGEYhRIt68K/cZMGfZff9YjQCMEvywhuZsmubOtO76I0gkCehJlCWA3S5FVwnjCkCKXqSGfmsGV/OuqqqKdfQyqtm27elvctKL46qC/hvRttvt+LJdLYZY6G2kLeQb/YR6yziWUUeq7XYyxYjFXy6Xg7wLKLvJZCIhCF4BUFFnJAAt27s+GAw82g2w+fHxsYYnBQAfcUQCELGRAbg8wAEwwchZrVY9xJXpcDhUkQpA5QMegBUqPM/L+EACYI8kACEf0IabjYl6n5+fCh8wNpvNBB0AUD6AAQwvgD/S4XAQOLsEQRoAImefBSW9Xs/hBJRSgmwANh+gP8AAIPMBDCGIShCF60YMwKMFQOe6UZ7nDDhSXcuUA+RCnlMGm7quOY7AAgSx6HXTyLhzAkURhN8WLZqm8buA4IK4/PYaWZaDjgFc11Xw5bQUQBG+HUAUAfx/uZaL4jt82wdB0F+UAsB39vL+YQjgZvUG9Nfr53/LRDQMEHd7NNYAktQhj+ssSwPEw96VFECSqmV+c3nXcRwQ4ZOzsZ8ASC3LLl0BE4JzRcyCIMtAhOTpXQ2L9S1V9X3b1rTjUdd/QCm8/PhL1r8HCnn3FRZ16P8CjQFDIKgjxC0DTbO1Y+CET9r/AD6sQgM7VcTdAAAAAElFTkSuQmCC"

/***/ })

}]);